<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>
<script type="text/javascript">
	export default {
		name: 'App',
		components: {},
		data() {
			return {
				
			}
		},
		methods : {
			
		}
	}
</script>
